import AppLayout from '../layouts/AppLayout'

const arme_tipo1 = 1
const arme_id21 = 21
const arme_id2 = 2
const arme_id20 = 20
const arme_tipo3 = 3
const arme_id83 = 83
const arme_id79 = 79
const arme_tipo4 = 4

export const consultar = {
  path: '/consultar',
  name: 'consultar',
  component: AppLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: ':arme_tipo?/:arme_id?',
      name: 'consultar.index',
      component: () =>
        import(
          /* webpackChunkName: "consultar.index" */ '@/views/new-menu/consultar/Index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar'
          }
        ]
      }
    },
    {
      path: 'inventario/luminarias/:arme_tipo?/:arme_id?',
      name: 'consultar.luminarias',
      component: () =>
        import(
          /* webpackChunkName: "consultar.luminarias" */ '@/views/new-menu/consultar/luminarias/Index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Luminarias'
          }
        ]
      }
    },
    {
      path: 'inventario/luminarias/activa/:arme_tipo?/:arme_id?',
      name: 'consultar.luminarias.activa',
      component: () =>
        import(
          /* webpackChunkName: "consultar.luminarias.activa" */ '@/views/inventario/menu1luminaria/menu1-1activa/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Luminaria',
            to: {
              name: 'consultar.luminarias',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id20 }
            },
            active: true
          },
          {
            text: 'Activa'
          }
        ]
      }
    },
    {
      path: 'inventario/luminarias/activa/editar/:arme_tipo?/:arme_id?/:id?',
      name: 'consultar.luminarias.activa.edit',
      component: () =>
        import(
          /* webpackChunkName: "consultar.luminarias.activa.edit" */ '@/views/inventario/menu1luminaria/menu1-1activa/gestion/edit/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Luminaria',
            to: {
              name: 'consultar.luminarias',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id20 }
            },
            active: true
          },
          {
            text: 'Activa',
            to: {
              name: 'consultar.luminarias.activa',
              params: { arme_tipo: arme_tipo4, arme_id: arme_id79 }
            },
            active: true
          },
          {
            text: 'Editar'
          }
        ]
      }
    },
    {
      path: 'inventario/luminarias/activa/crear/:arme_tipo?/:arme_id?/:id?',
      name: 'consultar.luminarias.activa.create',
      component: () =>
        import(
          /* webpackChunkName: "consultar.luminarias.activa.create" */ '@/views/inventario/menu1luminaria/menu1-1activa/gestion/create/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Luminaria',
            to: {
              name: 'consultar.luminarias',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id20 }
            },
            active: true
          },
          {
            text: 'Activa',
            to: {
              name: 'consultar.luminarias.activa',
              params: { arme_tipo: arme_tipo4, arme_id: arme_id79 }
            },
            active: true
          },
          {
            text: 'Crear'
          }
        ]
      }
    },
    {
      path: 'inventario/luminarias/enbaja/:arme_tipo?/:arme_id?',
      name: 'consultar.luminarias.enbaja',
      component: () =>
        import(
          /* webpackChunkName: "consultar.luminarias.enbaja" */ '@/views/inventario/menu1luminaria/menu1-2enbaja/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Luminaria',
            to: {
              name: 'consultar.luminarias',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id20 }
            },
            active: true
          },
          {
            text: 'En baja'
          }
        ]
      }
    },
    {
      path: 'inventario/luminarias/buscarporcodigo/:arme_tipo?/:arme_id?',
      name: 'consultar.luminarias.buscarporcodigo',
      component: () =>
        import(
          /* webpackChunkName: "consultar.luminarias.buscarporcodigo" */ '@/views/inventario/menu1luminaria/menu1-3porcodigo/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Luminaria',
            to: {
              name: 'consultar.luminarias',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id20 }
            },
            active: true
          },
          {
            text: 'Buscar Por Código'
          }
        ]
      }
    },
    {
      path: 'inventario/luminarias/buscarpormaterial/:arme_tipo?/:arme_id?',
      name: 'consultar.luminarias.buscarpormaterial',
      component: () =>
        import(
          /* webpackChunkName: "consultar.luminarias.buscarpormaterial" */ '@/views/inventario/menu1luminaria/menu1-6pormaterial/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Luminaria',
            to: {
              name: 'consultar.luminarias',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id20 }
            },
            active: true
          },
          {
            text: 'Buscar Por Material'
          }
        ]
      }
    },
    {
      path: 'inventario/control/:arme_tipo?/:arme_id?',
      name: 'consultar.control',
      component: () =>
        import(
          /* webpackChunkName: "consultar.control.index" */ '@/views/new-menu/consultar/control/Index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Control'
          }
        ]
      }
    },
    {
      path: 'inventario/control/activa/:arme_tipo?/:arme_id?',
      name: 'consultar.control.activa',
      component: () =>
        import(
          /* webpackChunkName: "consultar.control.activa" */ '@/views/inventario/menu2control/menu2-1activa/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Control',
            to: {
              name: 'consultar.control',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id21 }
            },
            active: true
          },
          {
            text: 'Activa'
          }
        ]
      }
    },
    {
      path: 'inventario/control/activa/editar/:arme_tipo?/:arme_id?/:id?',
      name: 'consultar.control.activa.edit',
      component: () =>
        import(
          /* webpackChunkName: "consultar.control.activa.edit" */ '@/views/inventario/menu2control/menu2-1activa/gestion/edit/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Control',
            to: {
              name: 'consultar.control',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id20 }
            },
            active: true
          },
          {
            text: 'Activa',
            to: {
              name: 'consultar.control.activa',
              params: { arme_tipo: arme_tipo4, arme_id: arme_id79 }
            },
            active: true
          },
          {
            text: 'Editar'
          }
        ]
      }
    },
    {
      path: 'inventario/control/activa/crear/:arme_tipo?/:arme_id?/:id?',
      name: 'consultar.control.activa.create',
      component: () =>
        import(
          /* webpackChunkName: "consultar.control.activa.create" */ '@/views/inventario/menu2control/menu2-1activa/gestion/create/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Control',
            to: {
              name: 'consultar.control',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id20 }
            },
            active: true
          },
          {
            text: 'Activa',
            to: {
              name: 'consultar.control.activa',
              params: { arme_tipo: arme_tipo4, arme_id: arme_id79 }
            },
            active: true
          },
          {
            text: 'Crear'
          }
        ]
      }
    },
    {
      path: 'inventario/control/enbaja/:arme_tipo?/:arme_id?',
      name: 'consultar.control.enbaja',
      component: () =>
        import(
          /* webpackChunkName: "consultar.control.enbaja" */ '@/views/inventario/menu2control/menu2-2enbaja/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Control',
            to: {
              name: 'consultar.control',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id21 }
            },
            active: true
          },
          {
            text: 'En Baja'
          }
        ]
      }
    },
    {
      path: 'inventario/transformador/:arme_tipo?/:arme_id?',
      name: 'consultar.transformador',
      component: () =>
        import(
          /* webpackChunkName: "consultar.transformador" */ '@/views/new-menu/consultar/transformador/Index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Transformador'
          }
        ]
      }
    },
    {
      path: 'inventario/transformador/activa/:arme_tipo?/:arme_id?',
      name: 'consultar.transformador.activa',
      component: () =>
        import(
          /* webpackChunkName: "consultar.transformador.activa" */ '@/views/inventario/menu6transformador/menu6-1activa/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Transformador',
            to: {
              name: 'consultar.transformador',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id21 }
            },
            active: true
          },
          {
            text: 'Activa'
          }
        ]
      }
    },
    {
      path: 'inventario/transformador/activa/editar/:arme_tipo?/:arme_id?/:id?',
      name: 'consultar.transformador.activa.edit',
      component: () =>
        import(
          /* webpackChunkName: "consultar.transformador.activa.edit" */ '@/views/inventario/menu6transformador/menu6-1activa/gestion/edit/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Transformador',
            to: {
              name: 'consultar.transformador',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id21 }
            },
            active: true
          },
          {
            text: 'Activa',
            to: {
              name: 'consultar.transformador.activa',
              params: { arme_tipo: arme_tipo4, arme_id: arme_id83 }
            },
            active: true
          },
          {
            text: 'Editar'
          }
        ]
      }
    },
    {
      path: 'inventario/transformador/activa/crear/:arme_tipo?/:arme_id?/:id?',
      name: 'consultar.transformador.activa.create',
      component: () =>
        import(
          /* webpackChunkName: "consultar.transformador.activa.create" */ '@/views/inventario/menu6transformador/menu6-1activa/gestion/create/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Transformador',
            to: {
              name: 'consultar.transformador',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id21 }
            },
            active: true
          },
          {
            text: 'Activa',
            to: {
              name: 'consultar.transformador.activa',
              params: { arme_tipo: arme_tipo4, arme_id: arme_id83 }
            },
            active: true
          },
          {
            text: 'Crear'
          }
        ]
      }
    },
    {
      path: 'inventario/transformador/enbaja/:arme_tipo?/:arme_id?',
      name: 'consultar.transformador.enbaja',
      component: () =>
        import(
          /* webpackChunkName: "consultar.transformador.enbaja" */ '@/views/inventario/menu6transformador/menu6-2enbaja/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Transformador',
            to: {
              name: 'consultar.transformador',
              params: { arme_tipo: arme_tipo3, arme_id: arme_id21 }
            },
            active: true
          },
          {
            text: 'En Baja'
          }
        ]
      }
    },
    {
      path: 'inventario/historialluminaria/:arme_tipo?/:arme_id?',
      name: 'consultar.historialluminaria',
      component: () =>
        import(
          /* webpackChunkName: "consultar.historialluminaria" */ '@/views/inventario/menu1luminaria/menu1-4historia/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Historial Luminaria'
          }
        ]
      }
    },
    {
      path: 'formatos/enblanco/:arme_tipo?/:arme_id?',
      name: 'consultar.formatos.enblanco',
      component: () =>
        import(
          /* webpackChunkName: "consultar.formatos.enblanco" */ '@/views/proceso/menu5formato/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Consultar',
            to: {
              name: 'consultar.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id2 }
            }
          },
          {
            text: 'Formatos En Blanco'
          }
        ]
      }
    },
    {
      path: 'reportes/luminarias/:arme_tipo?/:arme_id?',
      name: 'consultar.reportes.luminarias',
      component: () =>
        import(
          /* webpackChunkName: "consultar.reportes.luminarias" */ '@/views/interventoria/menu1reporte/menu1-1list/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Reportes',
            to: { name: 'reportes.index' }
          },
          {
            text: 'Luminarias'
          }
        ]
      }
    }
  ]
}
